import React, { Fragment } from "react";
import { ContactForm } from "../components/Contact/ContactForm";
import { Map } from "../components/Global/Map";
import { PageHero } from "../components/Global/PageHero";
import { BackToTop } from "../templates/BackToTop";

export const Contact = () => (
  <Fragment>
    <PageHero
      eyebrow="Reach Out"
      title="Contact"
      highlight="Us"
      subtitle="Reach out to us for spiritual counselling, prayers, and inquiries."
    />
    <ContactForm />
    <Map />
    <BackToTop />
  </Fragment>
);
